import { useEffect } from 'react';

import { Button, Icon, IconButton, Progress } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './schedule.module.css';

export interface Props {
  onNavigate: (keyword: string) => void;
  onView: (view: string) => void;
  setViewDate: (date: any) => void;
  setView: (option: string) => void;
  label: string;
  view: string;
  date: any;
  loading: boolean;
  showPmOnly?: boolean;
  showProjectedPms?: boolean;
  onTogglePmOnly?: () => void;
  onToggleProjected?: () => void;
}

const WorkCalendarToolbar = ({
  onNavigate,
  label,
  onView,
  view,
  setViewDate,
  setView,
  date,
  loading,
  showPmOnly,
  showProjectedPms,
  onTogglePmOnly,
  onToggleProjected,
}: Props) => {
  useEffect(() => {
    setViewDate(date);
  }, [setViewDate, date]);

  const onChange = option => {
    onView(option);
    setView(option);
  };

  return (
    <div className={classes.calendarToolbarContainer}>
      <div className={classes.calendarToolbarLeftControls}>
        <Button
          style={{
            color: colors.neutral.white,
            border: `1px solid ${colors.neutral.white}`,
            backgroundColor: colors.brand.orange,
          }}
          onClick={() => onNavigate('TODAY')}
        >
          Today
        </Button>
        <div className={classes.dateLabel}>{label}</div>
        <IconButton onClick={() => onNavigate('PREV')}>
          <Icon color={colors.neutral.white}>keyboard_arrow_left</Icon>
        </IconButton>
        <IconButton onClick={() => onNavigate('NEXT')}>
          <Icon color={colors.neutral.white}>keyboard_arrow_right</Icon>
        </IconButton>
        {onTogglePmOnly && (
          <Button
            size="small"
            style={{
              color: colors.neutral.white,
              backgroundColor: showPmOnly
                ? colors.opacity.black0_2
                : 'transparent',
              border: `1px solid ${colors.opacity.white0_6}`,
              marginLeft: '1rem',
              textTransform: 'none',
            }}
            onClick={onTogglePmOnly}
          >
            {showPmOnly && <Icon color={colors.neutral.white}>check</Icon>}
            PM only
          </Button>
        )}
        {onToggleProjected && (
          <Button
            size="small"
            style={{
              color: colors.neutral.white,
              backgroundColor: showProjectedPms
                ? colors.opacity.black0_2
                : 'transparent',
              border: `1px solid ${colors.opacity.white0_6}`,
              marginLeft: '0.5rem',
              textTransform: 'none',
            }}
            onClick={onToggleProjected}
          >
            {showProjectedPms && <Icon color={colors.neutral.white}>check</Icon>}
            Show projected PMs
          </Button>
        )}
      </div>
      <div className={classes.rightContainer}>
        {loading && (
          <div className={classes.loadingContainer}>
            <Progress
              size={20}
              thickness={1.5}
              progressColor={colors.neutral.white}
            />
          </div>
        )}
        <div>
          <Button
            style={{
              color: colors.neutral.white,
              backgroundColor:
                view === 'month'
                  ? colors.opacity.black0_1
                  : colors.brand.orange,
            }}
            onClick={() => onChange('month')}
          >
            Month
          </Button>
          <Button
            style={{
              color: colors.neutral.white,
              backgroundColor:
                view === 'week' ? colors.opacity.black0_2 : colors.brand.orange,
            }}
            onClick={() => onChange('week')}
          >
            Week
          </Button>
          <Button
            style={{
              color: colors.neutral.white,
              backgroundColor:
                view === 'day' ? colors.opacity.black0_2 : colors.brand.orange,
            }}
            onClick={() => onChange('day')}
          >
            Day
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WorkCalendarToolbar;
